import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FileSearch } from "lucide-react";
import StudentProfileHeader from "./StudentProfileHeader";
import InstructorProfileInformation from "./InstructorProfileInformation";
import InstructorAvailableTimeSlots from "./InstructorAvailableTimeSlots";
import InstructorLiveSessions from "./InstructorLiveSessions";
import InstructorAssignedCourses from "./InstructorAssignedCourses";
import InstructorRecentUploads from "./InstructorRecentUploads";
import InstructorExpertise from "./InstructorExpertise";
import TranscriptAiReportModal from "./TranscriptAiReportModal";
import { useGetInstructorProfileQuery } from "../../services/user/userApi";

const formatInstructorDisplayId = (instructorId) => {
  if (!instructorId) {
    return "-";
  }

  const idSuffix = String(instructorId).slice(-3).toUpperCase();
  return `ID-INS-${idSuffix}`;
};

const InstructorProfileView = () => {
  const navigate = useNavigate();
  const { instructorId } = useParams();

  const { data: instructorProfileResponse } = useGetInstructorProfileQuery(instructorId);
 
  const [isAiReportOpen, setIsAiReportOpen] = useState(false);

  const instructorProfile = instructorProfileResponse?.data;
  const profileInformation = instructorProfile?.profileInformation;
  const instructorInformation = instructorProfile?.instructorInformation;
  const availability = instructorProfile?.availability || [];
  const liveSessions = instructorProfile?.liveSessions || [];
  const assignedCourses = instructorProfile?.assignedCourses || [];
  const hasTranscript = Boolean(instructorInformation?.transcript?.secureUrl);

  const instructorName =
    profileInformation?.firstName + " " + profileInformation?.lastName || "Instructor";
  const instructorStatus = profileInformation?.accountStatus || "Active";
  const instructorEmail =
    profileInformation?.email  || "johndoe23@gmail.com";
  const instructorProfilePicture =
    profileInformation?.profilePicture.secureUrl || "";

  const statusKey = instructorStatus.toLowerCase();
  const toggleActionLabel = statusKey === "active" ? "Inactive" : "Active";

  return (
    <section className="min-h-screen bg-white px-4 pb-8 pt-4 font-['Roboto'] sm:px-5 xl:px-6 desktop:pl-9 desktop:pr-6 desktop:pb-10">
      <StudentProfileHeader
        title="Instructor Profile"
        name={instructorName}
        displayId={formatInstructorDisplayId(instructorId)}
        status={instructorStatus}
        profilePicture={instructorProfilePicture}
        onBack={() => navigate(-1)}
        actions={
          hasTranscript ? (
            <button
              type="button"
              onClick={() => setIsAiReportOpen(true)}
              className="inline-flex items-center gap-2 rounded-lg border border-[#923D8C] bg-white px-4 py-2 text-sm font-medium text-[#923D8C] transition hover:bg-[#923D8C0D]"
            >
              <FileSearch size={16} />
              View AI Report
            </button>
          ) : null
        }
      />

      <div className="mt-4 grid grid-cols-1 gap-x-5 gap-y-4 xl:grid-cols-2 xl:gap-x-6 desktop:gap-x-[38px]">
        <InstructorProfileInformation profileInformation={profileInformation} />
        <InstructorAvailableTimeSlots availability={availability} />
        <InstructorLiveSessions sessions={liveSessions} />
        <InstructorAssignedCourses courses={assignedCourses} />
        {/* <InstructorRecentUploads /> */}
        {/* <InstructorExpertise /> */}
      </div>

      <TranscriptAiReportModal
        isOpen={isAiReportOpen}
        onClose={() => setIsAiReportOpen(false)}
        instructorInformation={instructorInformation}
      />
    </section>
  );
};

export default InstructorProfileView;
